import { InjectionToken } from '@angular/core';

export const GCI_WEB_API_DEFAULT_DELAY = new InjectionToken<number>(
    'GCI_WEB_API_DEFAULT_DELAY'
);
